/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Phone_Is_Softphone_EnabledInputs */

const en_forms_users_settings_phone_is_softphone_enabled = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Softphone_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const de_forms_users_settings_phone_is_softphone_enabled = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Softphone_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone aktiviert`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Forms_Users_Settings_Phone_Is_Softphone_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_phone_is_softphone_enabled = /** @type {((inputs?: Forms_Users_Settings_Phone_Is_Softphone_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Phone_Is_Softphone_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_phone_is_softphone_enabled(inputs)
	return de_forms_users_settings_phone_is_softphone_enabled(inputs)
});